import { ProductGroup, Variant } from '../../../../../types/graphql'

export const getItemActiveColor = (
  productGroup: ProductGroup | null,
  selectedColor: string | undefined,
  globalColor: string | undefined,
  defaultColors: Record<string, string> | null
) => {
  const availableColors = productGroup?.colors.map(o => o.rawName) || []

  //priority 1: qs value for this particular product in the kit e.g. "womens-zamora-scrub-pants-color=Black" (assumes color exists for this product)
  const hasSelectedColor = selectedColor && availableColors.includes(selectedColor)

  //priority 2: generic qs value for color e.g. "color=Black"
  const hasGlobalColor = globalColor && availableColors.includes(globalColor)

  //priority 3: if this product group has only one available color, use that color
  const hasOnlyOneColor = availableColors.length === 1
  const firstProductColor = productGroup?.products[0]?.colorInfo?.rawName

  //priority 4: a default color is set for this product on the kit model in contentful
  const defaultColor = (defaultColors && defaultColors[productGroup?.handle || '']) || ''
  const hasValidDefaultColor = availableColors.includes(defaultColor)

  //priority 5: no other options are set, use default variant color
  const defaultVariantColor = productGroup?.defaultVariant.rawColor

  return hasSelectedColor
    ? selectedColor
    : hasGlobalColor
    ? globalColor
    : hasOnlyOneColor
    ? firstProductColor
    : hasValidDefaultColor
    ? defaultColor
    : defaultVariantColor
}

export const hasMissingSize = (selectedVariants: Variant[]) =>
  selectedVariants?.some(selectedVariant => {
    const hasSize = selectedVariant?.size
    const productGroupHasExactlyOneSize =
      selectedVariant?.productGroup && selectedVariant.productGroup?.sizes.length === 1
    return !hasSize && !productGroupHasExactlyOneSize
  }) ?? true

export const getDedupedHandles = (variants: Variant[] | undefined) => {
  if (!variants) return
  return [...new Set(variants.map(variant => variant.handle))]
}

export const getFlattenedVariants = (variantData: Array<{ variants: Variant[] }> | undefined) => {
  if (!variantData) return
  return Array.prototype.concat(...variantData.map(node => node.variants))
}
